import { StackNavigationProp } from "@react-navigation/stack"
import { createRef } from "react"

import { IRootParamList } from "./RootNavigator"

export const navigationRef = createRef<StackNavigationProp<IRootParamList>>()

export const navigate = (name: string, params: any) =>
  navigationRef?.current?.navigate(name, params)
